import { lazy, Suspense } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("@/pages/home/page"));
const HakkimizdaPage = lazy(() => import("@/pages/hakkimizda/page"));
const HizmetlerPage = lazy(() => import("@/pages/hizmetler/page"));
const ServiceDetailPage = lazy(() => import("@/pages/hizmetler/[slug]/page"));
const ReferanslarPage = lazy(() => import("@/pages/referanslar/page"));
const SSSPage = lazy(() => import("@/pages/sss/page"));
const IletisimPage = lazy(() => import("@/pages/iletisim/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const Fallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="w-8 h-8 border-2 border-[#1a3d2b] border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const wrap = (element: React.ReactNode) => (
  <Suspense fallback={<Fallback />}>{element}</Suspense>
);

const routes: RouteObject[] = [
  { path: "/", element: wrap(<HomePage />) },
  { path: "/hakkimizda", element: wrap(<HakkimizdaPage />) },
  { path: "/hizmetler", element: wrap(<HizmetlerPage />) },
  { path: "/hizmetler/:slug", element: wrap(<ServiceDetailPage />) },
  { path: "/referanslar", element: wrap(<ReferanslarPage />) },
  { path: "/sss", element: wrap(<SSSPage />) },
  { path: "/iletisim", element: wrap(<IletisimPage />) },
  { path: "*", element: wrap(<NotFound />) },
];

export default routes;
